import { Box, Button, Grid2, LinearProgress, Typography } from "@mui/material";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import React from "react";
import { ReactComponent as PerformanceIcon } from "Assets/Icons/Home/PerformanceIcon.svg";
import { ReactComponent as TrophyIcon } from "Assets/Icons/Home/TrophyIcon.svg";
import { ReactComponent as MentorIcon } from "Assets/Icons/Home/MentorIcon.svg";
import { ReactComponent as ProjectIcon } from "Assets/Icons/Home/ProjectIcon.svg";
import { ReactComponent as LiveIcon } from "Assets/Icons/Home/LiveIcon.svg";
import { ReactComponent as StreakIcon } from "Assets/Icons/Home/StreakIcon.svg";

const styles = (theme) => ({
  border: `1px solid ${theme.palette.border.blue}`,
  borderRadius: "8px",
  padding: "16px",
  display: "flex",
  "& .batchBox": {
    padding: "16px",
    "&>div": {
      display: "flex",
      "&>p": {
        "&:first-child": {
          whiteSpace: "nowrap",
          minWidth: "70px",
        },
      },
    },
  },
  "& .highlightBox": {
    width: "100%",
    "&>div": {
      "&:not(:first-child)": {
        border: `1px solid ${theme.palette.border.blue}`,
        borderRadius: "8px",
        padding: "16px",
        transition: "background-color 0.3s ease, color 0.3s ease",
        "&:hover": {
          background: theme.palette.primary.main,
          color: theme.palette.white.main,
          "& svg": {
            fill: theme.palette.white.main,
          },
          "& button": {
            borderColor: theme.palette.white.main,
            color: theme.palette.white.main,
          },
        },
      },
    },
    "& .icon": {
      minWidth: "18px",
    },
  },
});

const HomeCards = () => {
  return (
    <Grid2 sx={styles}>
      <Grid2
        columns={{ xl: 10, lg: 10, md: 6, sm: 4, xs: 2 }}
        className="highlightBox"
        spacing={2}
        container
      >
        <Grid2 size={2} className="batchBox">
          <Box>
            <Typography fontWeight={500}> Batch : </Typography>
            <Typography>DSML June24 Beginner w/o SQL- Tableau</Typography>
          </Box>
          <Box>
            <Typography fontWeight={500}> Schedule : </Typography>
            <Typography>Tue 09:00 PM | Thu 09:00 PM | Sat 09:00 PM</Typography>
          </Box>
        </Grid2>
        <Grid2 size={2} display={"flex"} flexDirection={"column"} gap={"10px"}>
          <Box display={"flex"} alignItems={"center"} gap={"5px"}>
            <PrimaryIcon
              height="18px"
              width="18px"
              icon={PerformanceIcon}
              className="icon"
            />
            <Typography variant="subtitle" fontWeight={500}>
              Performance
            </Typography>
            <Box
              sx={(theme) => ({
                borderRadius: "4px",
                padding: "4px 8px",
                background: theme.palette.yellow.main,
                marginLeft: "auto",
              })}
            >
              <Typography variant="body2">New</Typography>
            </Box>
          </Box>
          <Typography>
            Updated every 30 mins. Refresh page to see latest metrics.
          </Typography>
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Typography variant="subtitle">Rank</Typography>
            <Typography variant="subtitle">
              {" "}
              <PrimaryIcon height="14px" width="14px" icon={TrophyIcon} /> 25
            </Typography>
          </Box>
        </Grid2>
        <Grid2 size={2} display={"flex"} flexDirection={"column"}>
          <Box display={"flex"} alignItems={"center"} gap={"5px"} mb={"10px"}>
            <PrimaryIcon
              height="18px"
              width="18px"
              icon={MentorIcon}
              className="icon"
            />
            <Typography variant="subtitle" fontWeight={500}>
              Mentor Sessions (2/20)
            </Typography>
          </Box>
          <Box>
            <Typography>1-1 Expert Mock Interviews</Typography>
            <Box display={"flex"} alignItems={"center"} gap="10px">
              <LinearProgress
                color="success"
                variant="determinate"
                primary
                value={20}
              />
              <Typography>02/10</Typography>
            </Box>
          </Box>
          <Box>
            <Typography>1-1 Career Mentor Sessions</Typography>
            <Box display={"flex"} alignItems={"center"} gap="10px">
              <LinearProgress
                color="success"
                variant="determinate"
                primary
                value={20}
              />
              <Typography>02/10</Typography>
            </Box>
          </Box>
        </Grid2>
        <Grid2 size={2} display={"flex"} flexDirection={"column"} gap={"10px"}>
          <Box display={"flex"} alignItems={"center"} gap={"5px"}>
            <PrimaryIcon
              height="18px"
              width="18px"
              icon={ProjectIcon}
              className="icon"
            />
            <Typography variant="subtitle" fontWeight={500}>
              Projects
            </Typography>
          </Box>
          <Box>
            <Typography>Project</Typography>
            <Box display={"flex"} alignItems={"center"} gap="10px">
              <LinearProgress
                color="success"
                variant="determinate"
                primary
                value={0}
              />
              <Typography>0%</Typography>
            </Box>
          </Box>
          <Box>
            <Button
              sx={{ marginLeft: "auto", display: "flex" }}
              color="secondary"
              variant="outlined"
              size="small"
            >
              View Full Profile
            </Button>
          </Box>
        </Grid2>
        <Grid2 size={2} display={"flex"} flexDirection={"column"} gap={"15px"}>
          <Box display={"flex"} alignItems={"center"} gap={"5px"}>
            <PrimaryIcon
              height="18px"
              width="18px"
              icon={LiveIcon}
              className="icon"
            />
            <Typography variant="subtitle" fontWeight={500}>
              Live Updates
            </Typography>
          </Box>
          <Box
            sx={(theme) => ({
              background: theme.palette.yellow.main,
              padding: "8px",
              borderRadius: "8px",
            })}
          >
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Typography>Congratulations Ayush</Typography>
              <Typography variant="body2">6 hour ago</Typography>
            </Box>
            <Box
              sx={(theme) => ({
                "& svg": {
                  background: theme.palette.white.main,
                  borderRadius: "50px",
                  padding: "2px",
                },
              })}
              display={"flex"}
              alignItems={"center"}
              gap="8px"
            >
              <StreakIcon />
              <Typography fontWeight={500}>
                Ayush completed 50 day streak!
              </Typography>
            </Box>
          </Box>
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default HomeCards;
